






import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  setup(props) {
    const prosList = computed(
      () =>
        props.product.pros_and_cons?.filter((item) => item.type === 'Pro') || []
    );
    const consList = computed(
      () =>
        props.product.pros_and_cons?.filter((item) => item.type === 'Con') || []
    );
    const hasPros = computed(() => prosList.value.length > 0);
    const hasCons = computed(() => consList.value.length > 0);

    return {
      prosList,
      consList,
      hasPros,
      hasCons
    };
  }
});
